import ActionTypes from './../common/ActionTypes';
import Constant from '../common/Constant';

const firebase = require('firebase/app');
require('firebase/auth');
require('firebase/firestore');
require('firebase/functions');

const moment = require('moment');

let recentActivityFetched = false;
let recentActivitySnapshot;

function setLoading(loading) {
  return {
    type: ActionTypes.PROJECTS_RECENT_ACTIVITY_LOADING,
    loading,
  };
}

function setFailed(isFailed) {
  return {
    type: ActionTypes.PROJECTS_RECENT_ACTIVITY_FAILED,
    isFailed,
  };
}

function recentActivityCreated(workLog) {
  return {
    type: ActionTypes.PROJECTS_RECENT_ACTIVITY_CREATED,
    workLog,
  };
}

function clearRecentActivity() {
  return {
    type: ActionTypes.PROJECTS_RECENT_ACTIVITY_CLEAR,
  };
}

function stopSync() {
  if (recentActivitySnapshot) {
    recentActivitySnapshot();
  }
}

function fetchRecentWorkLogs() {
  return dispatch => {
    const { currentUser } = firebase.auth();

    if (currentUser) {
      recentActivityFetched = false;
      dispatch(setLoading(true));
      dispatch(setFailed(false));
      dispatch(clearRecentActivity());
      stopSync();

      recentActivitySnapshot = firebase
        .firestore()
        .collection('workLogs')
        .where('ownerUid', '==', currentUser.uid)
        .where(
          'createdAt',
          '>=',
          moment()
            .subtract(3, 'day')
            .format(Constant.DATE_FORMAT),
        )
        .where('createdAt', '<=', moment().format(Constant.DATE_FORMAT))
        .onSnapshot(
          snapshot => {
            snapshot.docChanges().forEach(change => {
              const changeType = change.type;
              const workLog = change.doc.data();
              workLog.id = change.doc.ref.id;

              if (changeType === 'added') {
                dispatch(recentActivityCreated(workLog));
              }
            });

            if (!recentActivityFetched) {
              dispatch(setLoading(false));
              dispatch(setFailed(false));
            }

            recentActivityFetched = true;
          },
          () => {
            if (!recentActivityFetched) {
              dispatch(setLoading(false));
              dispatch(setFailed(true));
            }
          },
        );
    }
  };
}

export const projectActivityActions = {
  fetchRecentWorkLogs,
  stopSync,
};



// WEBPACK FOOTER //
// ./src/actions/projectActivity.js